import * as actionTypes from 'constants/ActionTypes';

const train = (state = {
    items: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
        case actionTypes.SEND_TRAIN.REQUEST:
            return {
                ...state,
            };
        case actionTypes.SEND_TRAIN.SUCCESS: {
            return {
                ...state,
                ...action.data,
                isLoaded: true,
            };
        }
        case actionTypes.SEND_TRAIN.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        default:
            return state;
    }
};

export default train;



// WEBPACK FOOTER //
// ./app/reducers/train.js